import Axios from "@app/api/axios";

import { ADMIN_CANDIDATE_API } from "@utils/constant";

export const updateCandidateDetailsAsAdminService = (consentId = "", payload) =>
  Axios.patch(`${ADMIN_CANDIDATE_API}/${consentId}`, payload);
